import store from '@/state/store';
import { leave } from '@/api/project';
import projectSlice from '@/state/project.slice';
import { handleError } from '@/actions/common';

export default async (projectId: string): Promise<void> => {
  try {
    await leave(projectId);
    store.dispatch(projectSlice.actions.removeProject(projectId));
  } catch (error) {
    handleError(error);
    throw error;
  }
};